import React, { useEffect, useMemo } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { GiftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../../layouts/MainLayout';
import { hasResource } from '../../../utils/resourceAuth';
import { ResourceCode } from '../../../constants/resourceCodes';
import { NoPermission } from '../../../components/NoPermission';
import { findFirstAvailableMenuItem } from '../../../utils/menuUtils';

/**
 * 司机运营模块布局：一级菜单 driver-ops，二级菜单本期只有「司机活动」。
 * 结构照 PartnerControlLayout：根路径自动跳第一个可见项，全不可见时兜底 NoPermission。
 */
const DriverOpsLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    const menuItems = [
        {
            key: 'activity',
            label: t('driverOps.menu.activity'),
            icon: <GiftOutlined />,
            display: hasResource([ResourceCode.menu.DRIVER_ACTIVITY]),
            onClick: () => navigate('/driver-ops/activity')
        }
    ];

    useEffect(() => {
        const isRoot = location.pathname === '/driver-ops' || location.pathname === '/driver-ops/';
        if (!isRoot) return;
        const first = findFirstAvailableMenuItem(menuItems);
        if (first?.onClick) first.onClick();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    const hasVisibleMenu = useMemo(
        () => findFirstAvailableMenuItem(menuItems) !== null,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [menuItems]
    );

    return (
        <MainLayout activeFirstMenu="driver-ops" secondMenu={menuItems}>
            <div className="p-6 h-full flex flex-col">
                {hasVisibleMenu ? <Outlet /> : <NoPermission />}
            </div>
        </MainLayout>
    );
};

export default DriverOpsLayout;
